import classnames from "classnames";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

import { Tooltip } from "@mui/material";
import Icon from "../../Icon";
import { FormControl } from "../Form";
import FormInput from "../FormInput";

const Checkbox = ({
  name,
  label,
  subLabel,
  size,
  options,
  className,
  tooltip,
}) => {
  const { register } = useFormContext();
  return (
    <FormControl>
      <FormInput
        type="checkbox"
        className={classnames(className, {
          "is-disabled": options?.disabled,
        })}
      >
        <div
          className={classnames("form-input-field", {
            [`form-input-field--${size}`]: size,
          })}
        >
          <Tooltip title={tooltip}>
            <input
              type="checkbox"
              id={name}
              name={name}
              disabled={options?.disabled || options?.readOnly}
              readOnly={options?.disabled || options?.readOnly}
              defaultChecked={options?.checked}
              {...register(name)}
            />
          </Tooltip>
          <span className="form-input-checkbox">
            <Icon
              name="system-checkmark"
              size="small"
              style={
                options?.disabled && options?.checked
                  ? { display: "block", color: "grey" }
                  : {}
              }
            />
          </span>
        </div>
        <label htmlFor={name}>
          {label}
          {subLabel && <span>{subLabel}</span>}
        </label>
        {options?.locked && (
          <Icon
            name="lock-solid"
            size="extra-small"
            className="icon--lock-card"
          />
        )}
      </FormInput>
    </FormControl>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  size: PropTypes.oneOf(["small", "default", "large"]),
  options: PropTypes.object,
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  size: "default",
};

export default Checkbox;
